import { render, staticRenderFns } from "./flowPoolUseDetail.vue?vue&type=template&id=615137bc&scoped=true&"
import script from "./flowPoolUseDetail.vue?vue&type=script&lang=js&"
export * from "./flowPoolUseDetail.vue?vue&type=script&lang=js&"
import style0 from "./flowPoolUseDetail.vue?vue&type=style&index=0&id=615137bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615137bc",
  null
  
)

export default component.exports